<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">单灯列表</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="回路通讯地址" prop="IdAddress">
            <el-input
              v-model="IdAddress"
              placeholder="请输入回路通讯地址"
            ></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="IdAddress"
                label="回路通讯地址"
              ></el-table-column>
               <el-table-column
                prop="Leakc"
                label="漏电流/(A)"
              ></el-table-column>
              <el-table-column
                prop="Vf"
                label="电压频率/(Hz)"
              ></el-table-column>
              <el-table-column prop="State" label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.State == 2" style="color: red"
                    >离线</span
                  >
                  <span
                    v-else-if="scope.row.State == 1"
                    style="color: green"
                    >在线</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="StateTime"
                label="时间"
              ></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "LampView",
  controller: "UI",
  action: "LampView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [
        {
          Id:1,
          IdAddress: "6304",
          State: 1,
          StateTime: "2020-12-07 16:37:53",
          Leakc: 0,
          Vf:50,
          LampIndex:1
        },
        {
          Id:2,
          IdAddress: "6304",
          State: 1,
          StateTime: "2020-12-07 16:37:53",
          Leakc: 0,
          Vf:50,
          LampIndex:1
        },
      ],
      IdAddress: "",
      loading: false,
      loadingText: "加载中...",
    };
  },
  created: function () {
  },
  mounted: function () {
    // this.search();
    this.getList();
  },
  methods: {
    getList() {
      this.tableData.forEach((item) => {
        //"ioout": [1, 1, 2, 2],  //回路开关，索引：0-3代表回路1-4，值：1:开，2关
        var loopData = item.IOOut.replace("[", "").replace("]", "").replace(/\s*/g,"");
        var loopDatas = new Array();
        loopDatas = loopData.split(",");
        if (loopDatas.length >= 4) {
          item["loop1"] = loopDatas[0];
          item["loop2"] = loopDatas[1];
          item["loop3"] = loopDatas[2];
          item["loop4"] = loopDatas[3];
        }
      });
      console.log(this.tableData);
    },
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          this.EqRegionArr = r;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search() {
      let searchInfo = {
        TRASHNAME: this.deviceName,
        BELONGAREA: this.RegionId == "" ? null : this.RegionId,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      this.loading = true;
      new MyApis.TranResourcesApi()
        .GetPageContentByConditions(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.ContentList;
          this.total = r.TotalCount;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/lamp/ui/LampConcentratorInfo",
        query: { InfoId: row.Id, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/lamp/ui/LampConcentratorInfo",
        query: { InfoId: row, type: "edit" },
      });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.deviceName = "";
      this.RegionId = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
